import React, { Component } from 'react';
import { Button, Modal, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractReviewerActions as actions } from '../../actions';
import AuthService from "../../services/auth.service";

import '../../content/css/ExportDocumentModal.css';
import ToggleSwitch from '../ToggleSwitch';

class UserSettingsModal extends Component {
    constructor(props, context) {
        super(props, context);

        this.authService = new AuthService();

        this.state = {
            show: false,
            allowThirdPartyAI: this.authService.userAllowsThirdPartyAI()
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    }

    handleClose = () => {
        this.setState({ show: false });
    }

    handleThirdPartyAIToggle = (value) => {
        this.setState({ allowThirdPartyAI: value });
        this.authService.setUserAllowsThirdPartyAI(value);
    }

    getTooltip = (text) => {
        return (
            <Tooltip placement="right">
                {text}
            </Tooltip>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OverlayTrigger overlay={this.getTooltip("Settings")}>
                    <div>
                        <div className="menu-btn" onClick={this.handleShow}>
                            <Glyphicon glyph="cog" />
                        </div>
                    </div>
                </OverlayTrigger>

                <Modal className="export-document-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>User Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="panel-title-column">
                            <span className="panel-title">Preferences</span>
                        </div>
                        <div className="section-toggles">
                            <div>
                                <span>Allow third-party AI tools</span>
                                <ToggleSwitch
                                    initialValue={this.state.allowThirdPartyAI}
                                    onChange={this.handleThirdPartyAIToggle}
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(UserSettingsModal);



// WEBPACK FOOTER //
// ./src/components/Home/SettingsModal.js